import $ from 'jquery';

$(function () {
	$('#reference-group-list-table tr').each(function () {
		$(this).clickableRow('btn-detail');
	});

	$('body').on('change', '#reference-group-filter input', function () {
		var checked = [];
		$('#reference-group-filter input:checked').each(function () {
			checked.push($(this).val());
		});

		$('#reference-group-list-table tbody tr').each(function () {
			var tr = $(this);
			var groupType = tr.attr('group-type');
			if (checked.indexOf(groupType) >= 0) {
				tr.show();
			} else {
				tr.hide();
			}
		});
	});
});
